/** @prettier */

import {useParams} from 'react-router-dom';
//Style import
import '../../css/common/common.css';

import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
} from '@mui/material';
import {Dispatch, SetStateAction, useEffect, useState} from 'react';

import {postCompositionsAllUnit} from '../../API/API_Collection';
import {PrimaryButton, SecondaryButton} from '../../component/BasicButton';
import {useTranslation} from 'react-i18next';
import APIErrorMessage from '../../component/APIErrorMessage';

/**
 * 一括登録確認ダイアログ
 * @param props props
 * @returns JSX
 * - open ダイアログを開く変数
 * - setOpen openのセット関数
 * - setApplyButton 一括登録ダイアログのApplyボタンのセット関数
 * - setParentClose 一括登録ダイアログのcloseのセット関数
 * - csvData APIに渡すCSVデータ
 * - gwID ゲートウェイID
 * - CONFIG UPDATEボタンを表示するGW一覧
 * - CONFIG UPDATEボタンを表示するGW一覧のセット関数
 */
const CollectiveSettingAddDialog = (props: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setApplyButton: React.Dispatch<React.SetStateAction<boolean>>;
  setParentClose: () => void;
  csvData: string;
  gwID: string;
  hasConfigGW: string[];
  setHasConfigGW: Dispatch<SetStateAction<string[]>>;
}) => {
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ
  const [checked, setChecked] = useState(false); //チェックボックス
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(true); //SAVEボタン非表示フラグ
  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false); //API使用時エラー発生ダイアログ表示フラグ
  //パスパラメータ取得
  const {siteID} = useParams();

  const gwID = props.gwID;
  const trans = useTranslation().t; //翻訳関数

  //入力項目のチェック
  useEffect(() => {
    if (checked && apiWait === false) {
      setSaveBtnDisabled(false);
    } else {
      setSaveBtnDisabled(true);
    }
  }, [checked, apiWait]);

  /**
   * チェックボックス押下時の処理
   * @param event
   */
  const handleChange1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    props.setOpen(false);
    props.setApplyButton(false);
    props.setParentClose();
    setChecked(false);
  };

  /**
   * 一括登録
   * @returns
   */
  const saveUnitCompositions = async () => {
    //パスパラメータを取得できない場合
    if (siteID === undefined) {
      return;
    }

    try {
      setAPIWait(true);

      // 一括登録
      await postCompositionsAllUnit(siteID, gwID, props.csvData);

      //一括登録したGWのConfigボタンを表示する
      props.setHasConfigGW([...props.hasConfigGW, gwID]);
      //Applyダイアログを閉じる
      props.setOpen(false);

      //親ダイアログのApplyボタンを無効化
      props.setParentClose();
    } catch (error) {
      // エラー処理
      setIsOpenErrorDialog(true);
    } finally {
      setChecked(false);
      setAPIWait(false);
    }
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title">
      <DialogTitle id="form-dialog-title">
        {trans('CollectiveSettingAddDialog.title')}
      </DialogTitle>

      <DialogContent className="collectiveSettingAddDialog__checkBox">
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleChange1}
              id={'collectiveSettingChkbox1'}
            />
          }
          checked={checked}
          label={trans('CollectiveSettingAddDialog.description.data')}
          sx={{
            alignItems: 'flex-start',
          }}
        />
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          disabled={apiWait}
          onClick={handleClose}
          buttonText={trans('CollectiveSettingAddDialog.button.cancel')}
          id={'mv-btnCancelAddGw'}
        />
        <PrimaryButton
          onClick={saveUnitCompositions}
          buttonText={trans('CollectiveSettingAddDialog.button.save')}
          id="mv-btnOkAddGw"
          disabled={saveBtnDisabled}
          apiWait={apiWait}
        />
        <APIErrorMessage
          open={isOpenErrorDialog}
          setOpen={setIsOpenErrorDialog}
          id="mv-btnErrAddGw"
        />
      </DialogActions>
    </Dialog>
  );
};
export default CollectiveSettingAddDialog;
